import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import {getData} from '../../services/index';
import {  QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined } from '@ant-design/icons';

const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}


class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			coupon_list : [],
			student_reports_list : [],
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			timeline: false,
			academic_year: '',
			amount: '',
			class: '',
			category_name: '',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.onChange_startdate = this.onChange_startdate.bind(this);
		this.onChange_enddate = this.onChange_enddate.bind(this);
		this.change_year = this.change_year.bind(this);
		this.change_section = this.change_section.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {school_id : school_id,user_id:user_id}
			getData('fees/get_student_reports_data_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_reports_list: result['data'],
						});
					}else{
						this.setState({
							student_reports_list: [],
						});
					}
				}
			});
			
	}
  }
	


  onChangechecked(checkedValues) {
	  this.setState({ checked_id: this.state.checked_id.concat(checkedValues) });
	}	
	
	onChange_startdate(date, dateString) {
	  this.setState({ start_date: dateString, });
	}
	
	onChange_enddate(date, dateString) {
	  this.setState({ end_date: dateString, });
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};
	
	change_year(event){
         this.setState({academic_year: event});
     }
	
	change_section(event){
         this.setState({class: event});
     }

		
	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}		
	}

	render() {

		return (
			<div class="mobile_view">
				<div id="main" class="bg-off">
					<div class="row">
						<div class="col col-md-12  ex-padd">
							<div id="breadcrumbs-wrapper" class="bg-off">
							   <div>
								  <div class="row no-margin">
									  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
										  <div class="col s12 m6 l6  pt-10 pb-15 ">
												<h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Student Reports</span></h5>
											 </div>
											 
											 <div class="col s12 m6 l6 right-align-md pt-10">
												<ol class="breadcrumbs mb-0">
												   <li class="breadcrumb-item"><a href="/">Home</a></li>
												   <li class="breadcrumb-item"><a href="/settings/fees">Fees Setting</a></li>
												   <li class="breadcrumb-item active">Student Reports</li>
												</ol>
											 </div>  
										 </div>
									  </div>
							   </div>
							</div>
						</div>
						<div class="col col-md-12  ex-padd enquiry bg-off">
							<div class="container">		
		            <div>
				     <section>										
					    <div class=""> 
                         <div class="dataTables_wrapper no-footer mh-500 ">
                          <div class="top display-flex flow-root ">
							<div class="actions action-btns display-block align-items-center col col-md-12  right no-padd">
								 <Link class="right" to={`${process.env.PUBLIC_URL}/student-reports/add`}>							 
								 <button className="action_btn mt-5"><PlusOutlined /> Add New</button>
								 </Link>
                             </div>
						</div>
                           
                        <div class="clear"></div>
						 
						<div class="table-responsive res mt-10">
						   <table class="cust_table data-list-view">
						  <thead>
							<tr>
								<th class="">#</th>
								<th class="">Student Name</th>
								<th class="">Program Name</th>
								<th class="">Report Date</th>
								<th>Action</th>
							</tr>
						  </thead>

						  <tbody>
							{this.state.student_reports_list.map((list)=>(
								<tr>
									<td data-label="Sr No">{list.sr_no}</td>
									<td data-label="Student Name">{list.student_name}</td>
									<td data-label="Program Name">{list.program_name}</td>
									<td data-label="Report Date"> {list.added_date}</td>
									<td data-label="Action">
				
									<div class="invoice-action">
									  <button class="action-btn pl-10" onClick={this.showMenu.bind(this,list.sr_no)}>
										 <MoreOutlined />
									  </button>
									  <div className="action-menu" id={`open_action_${list.sr_no}`}>
										<Link to={`${process.env.PUBLIC_URL}/student-reports/edit/${list.student_id}`}><li> <EditOutlined />View & Edit </li></Link>																
									</div>
									</div>							
									</td>
								</tr> 
							))}	
										 
										
										{(() => {  
														if (this.state.student_reports_list.length =='0') {
														return (
																<tr>
																	<td colspan="5">No Data Found</td>
																</tr> 
														)
												}
										})()}					
										
										
									  </tbody>
									</table>
				</div>
				
				
                        </div>
						</div>
										
									</section>
								</div>
								
								
							</div>
						</div>
           
					</div>
				</div>
			</div>
		) 
	} 
}
export default Index;
